export default __webpack_public_path__ + "static/media/Flag of Sri Lanka.b7f51858.gif";